<template>
  <div class="page-content">
    <page-template ref="archivesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="editColumns"
                   @getDetail="getDetail"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';

export default {
  components: {
    pageTemplate

  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: '', prop: 'name', type: 'input', ifFuzzy: true, placeholder: '请输入客户名称/编码'}
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert'
        },
        {
          label: '打印',
          code: 'print'
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel,
          filter: () => {
            return false
          }
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update'
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate
        }
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true, // 是否显示索引
        columns: [
          {label: '编码', prop: 'code', width: '120', align: 'center'},
          {label: '名称', prop: 'name', width: '120', align: 'center'},
          {label: '联系人', prop: 'liaison', width: '120', align: 'center'},
          {label: '联系方式', prop: 'phone', width: '120', align: 'center'},
          {label: '地址', prop: 'address', width: '200', align: 'center'},
          // {
          //   label: '状态',
          //   prop: 'status',
          //   width: '100',
          //   align: 'center',
          //   enumData: this.$utils.getCacheStatus('wlWholesaleCustomer.status')
          // },
          // {label: '创建门店', prop: 'storeName', width: '100', align: 'center'},
          {label: '创建时间', prop: 'createDttm', width: '140', align: 'center'}
          // {label: '备注', prop: 'remarks', width: '120', align: 'center',},
        ],
        url: api.wholesale.archives
      },
      // 添加字段
      addColumns: {
        labelWidth: '120px',
        span: 12,
        columns: [
          {
            label: '名称',
            type: 'input',
            prop: 'name',
            maxLength: 16,
            rule: [
              {required: true, message: '请输入名称', trigger: 'blur'}
            ],
            placeholder: '请输入名称',
            change: this.checkName
          },
          {
            label: '联系人',
            type: 'input',
            maxLength: 16,
            prop: 'liaison',
            rule: [
              {required: false, message: '请输入联系人', trigger: 'blur'}
            ],
            placeholder: '请输入联系人'
          },
          {
            label: '联系电话',
            type: 'input',
            prop: 'phone',
            maxLength: 11,
            rule: [
              {required: false, message: '请输入联系电话', trigger: 'blur'},
              {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
            ],
            placeholder: '请输入联系电话'
          },
          // {
          //   label: '客户地址',
          //   type: 'casaderSelect',
          //   prop: 'province',
          //   span: 24,
          //   specialRule: [{required: true}],
          //   casaderOptions: [{
          //     prop: 'province',
          //     data: [],
          //     childProps: 'city',
          //     param: {parentId: 0},
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择省！'}]
          //   }, {
          //     prop: 'city',
          //     data: [],
          //     childProps: 'area',
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择市！'}]
          //   }, {
          //     prop: 'area',
          //     data: [],
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择区！'}]
          //   }
          //   ]
          // },
          {
            label: '地址',
            type: 'input',
            maxLength: 32,
            prop: 'address'
          }
          // {
          //   label: "经度",
          //   type: "inputNumber",
          //   prop: "latitude",
          //   max: 180,
          //   min: -180,
          //   precision: 5,
          //   rule: [{required: false, message: "请选择区！"}]
          // },
          // {
          //   label: "纬度",
          //   type: "inputNumber",
          //   prop: "longitude",
          //   max: 90,
          //   min: -90,
          //   precision: 5,
          //   rule: [{required: false, message: "请选择区！"}]
          // },
          // {
          //   label: '',
          //   type: 'map',
          //   prop: 'map',
          //   span: 24,
          //   lat: 'latitude',
          //   lon: 'longitude',
          //   labelWidth: 120,
          // },
        ],
        url: api.wholesale.archives
      },
      // 编辑字段
      editColumns: {
        labelWidth: '120px',
        span: 12,
        columns: [
          {
            label: '编码',
            type: 'input',
            prop: 'code',
            placeholder: '请输入编码',
            disabled: true
          },
          {
            label: '名称',
            type: 'input',
            maxLength: 16,
            prop: 'name',
            rule: [
              {required: true, message: '请输入名称', trigger: 'blur'}
            ],
            placeholder: '请输入名称',
            change: this.checkNameEdit
          },
          {
            label: '联系人',
            type: 'input',
            maxLength: 16,
            prop: 'liaison',
            rule: [
              {required: false, message: '请输入联系人', trigger: 'blur'}
            ],
            placeholder: '请输入联系人'
          },
          {
            label: '联系电话',
            type: 'input',
            prop: 'phone',
            maxLength: 11,
            rule: [
              {required: false, message: '请输入联系电话', trigger: 'blur'},
              {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
            ],
            placeholder: '请输入联系电话'
          },
          // {
          //   label: '客户地址',
          //   type: 'casaderSelect',
          //   prop: 'province',
          //   span: 24,
          //   // specialRule: [{required: true}],
          //   casaderOptions: [{
          //     prop: 'province',
          //     data: [],
          //     childProps: 'city',
          //     param: {parentId: 0},
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择省！'}]
          //   }, {
          //     prop: 'city',
          //     data: [],
          //     childProps: 'area',
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择市！'}]
          //   }, {
          //     prop: 'area',
          //     data: [],
          //     url: api.getAreaList,
          //     rule: [{required: false, message: '请选择区！'}]
          //   }]
          // },
          {
            label: '地址',
            type: 'input',
            prop: 'address',
            maxLength: 32,
          }
          // {
          //   label: "经度",
          //   type: "inputNumber",
          //   prop: "latitude",
          //   max: 180,
          //   min: -180,
          //   precision: 5,
          //   rule: [{required: false, message: "请选择区！"}]
          // },
          // {
          //   label: "纬度",
          //   type: "inputNumber",
          //   prop: "longitude",
          //   max: 90,
          //   min: -90,
          //   precision: 5,
          //   rule: [{required: false, message: "请选择区！"}]
          // },
          // {
          //   label: '',
          //   type: 'map',
          //   prop: 'map',
          //   span: 24,
          //   lat: 'latitude',
          //   lon: 'longitude',
          //   labelWidth: 120,
          // },
        ],
        url: api.wholesale.archives
      }
    };
  },
  created() {
  },
  methods: {
    getDetail(val) {
      this.editData = this.$utils.deepClone(val);
    },
    checkFun(name) {
      return new Promise((resolve, reject) => {
        this.$axios.fetchGet(api.archives.customerName + '?customerName=' + name, {}).then(res => {
          this.loading = false;
          if (res.code == 200) {
            if (!res.data) {
              this.$message({type: 'warning', message: '名称重复'});
              this.isReaptName = false
            } else {
              this.isReaptName = true
            }
            resolve(this.isReaptName)
          } else {
            reject()
            this.$message({type: 'error', message: res.msg});
          }
        })
          .catch(err => {
          })
      })
    },
    // 新增 校验名称重复
    checkName(val) {
      this.checkFun(val.name).then(() => {
        if (!this.isReaptName) {
          val.name = ''
        }
      })
    },
    // 编辑 校验名称重复
    checkNameEdit(val) {
      if (this.editData.name && this.editData.name != val.name) {
        this.checkFun(val.name).then(() => {
          if (!this.isReaptName) {
            val.name = this.editData.name
          }
        })
      }
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/wholeasle/Archives.vue